module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hollandsnieuwe-intro-card1.1@2x.336b636c.jpg";